export var ConversionType;
(function (ConversionType) {
    ConversionType["CONVERT_SBD_TO_STEEM"] = "convert";
})(ConversionType || (ConversionType = {}));
